const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    marginTop: '8px',
  },
  sessionCard: {
    padding: '20px 24px',
    backgroundColor: '#FFFFFF',
    borderRadius: '16px',
    border: '1px solid #F1F5F9',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    transition: 'all 0.2s',
    '&:hover': {
      borderColor: '#E2E8F0',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
      transform: 'translateY(-1px)',
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '20px',
    },
  },
  sessionInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  sessionLabel: {
    fontSize: '16px',
    fontWeight: 700,
    color: '#1E293B',
  },
  sessionMeta: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flexWrap: 'wrap',
  },
  statusBadge: {
    fontSize: '11px',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.02em',
    padding: '4px 10px',
    borderRadius: '6px',
  },
  metaText: {
    fontSize: '13px',
    color: '#64748B',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  sessionActions: {
    display: 'flex',
    gap: '12px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      justifyContent: 'flex-end',
    },
  },
  actionButton: {
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: '8px',
    padding: '6px 16px',
    fontSize: '13px',
    boxShadow: 'none',
  },
  resumeBtn: {
    backgroundColor: '#0F172A',
    color: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#1E293B',
    },
  },
  secondaryBtn: {
    border: '1px solid #E2E8F0',
    color: '#475569',
    '&:hover': {
      backgroundColor: '#F8FAFC',
      borderColor: '#CBD5E1',
    },
  },
})

export default styles
